module.exports = __webpack_public_path__ + "media/images/lp/1/plight3-sp-10e1a004aa994e59a0f95a5cb812f6fd.png";